<script setup lang="ts">
import { computed, ref } from 'vue';
import { navigateTo, useOrganizationDomain } from '#imports';
import { AiSearchBar } from '~/components/ai-search-bar';
import { SearchInput } from '~/components/inputs/search-input';
import { useOrganizationStore } from '~/store/organization';

const { organization } = storeToRefs(useOrganizationStore());
const organizationDomain = useOrganizationDomain();

const isAiSearchEnabled = computed(
  () =>
    organizationDomain !== null &&
    organization.value?.isAiSearchEnabled === true,
);

const search = ref('');

const onSearchConfirm = () => {
  if (search.value.length === 0) {
    return;
  }

  navigateTo({ path: '/content/all-content', query: { search: search.value } });
};
</script>

<template>
  <AiSearchBar v-if="isAiSearchEnabled" class="w-full md:max-w-md" />
  <SearchInput
    v-else
    v-model="search"
    :placeholder="$t('dashboard.search-all-content')"
    hide-details
    @keyup.enter="onSearchConfirm"
  />
</template>
